@if (isVisible) {
  <div class="space-header">
    <div class="left">
      <ng-content select="[parent]"></ng-content>
      <div class="title">
        <ng-content select="[title]"></ng-content>
      </div>
    </div>
    <div class="right">
      <div class="tags">
        <ng-content select=".tag"></ng-content>
      </div>
      <div class="actions">
        <ng-content select="[actions]"></ng-content>
      </div>
      <div class="close" (click)="close()">
        <i class="fa fa-close"></i>
      </div>
    </div>
  </div>
}